/**
 * MenuItemIconContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled container for the menu item icon.
 */
const MenuItemIconContainer = styled.div`
  margin-right: ${16 * Screen.widthRatio}px;
  width: ${24 * Screen.widthRatio}px;
`;

export default MenuItemIconContainer;
